import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ParentComplaintsIndexLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ParentComplaintsIndex' */ './components/ParentComplaintsIndex'
		)
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<ParentComplaintsIndexLazy />} />,
	};
};
